import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios'
import { Alert, Container, Row, Button, Card, CardHeader, CardBody} from "shards-react";
import { Redirect, Link } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';


const parentUrl = process.env.REACT_APP_RE_URL;


class Endpoints extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      loading: true,
      alertVisible: true,
      endpoints: [],
      apiActionErr: null,
      apiErr: null
    }
  }

  _getEndpoints() {
    const token = auth.getAccessToken()
    const url = parentUrl + "/smre/1.0/uris";
    const self = this;

    axios.get(
      url,
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer "+token
        }
      }
    ).then(function (response) {

      var endpoints = response.data.uris;

      self.setState({
        loading: false,
        endpoints: endpoints,
        apiActionErr: null,
        apiErr: null
      })

      if (endpoints.length > 0){
        setTimeout(self.loadTable, 200);
      }
    }).catch(function (error) {

      self.setState({
        loading: false,
        apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error
      })

    });
  }


  loadTable = () => {

    $('#endpointsTable').DataTable({
        "ordering": false,
        "destroy": true,
        "lengthMenu": [[5, 10, 20, -1], [5, 10, 20, this.context.t('All')]],
        "columnDefs": [
            {
            targets: [ 0 ],
                className: 'mdl-data-table__cell--non-numeric'
            }
        ],
        "language": {
             "sProcessing":     this.context.t("Processing..."),
             "sLengthMenu":     this.context.t("Show _MENU_ entries"),
             "sZeroRecords":    this.context.t("No matching records found"),
             "sEmptyTable":     this.context.t("No data available in table"),
             "sInfo":           this.context.t("Showing _START_ to _END_ of _TOTAL_ entries"),
             "sInfoEmpty":      this.context.t("Showing 0 to 0 of 0 entries"),
             "sInfoFiltered":   this.context.t("(filtered from _MAX_ total entries)"),
             "sInfoPostFix":    "",
             "sSearch":         this.context.t("Search"),
             "sUrl":            "",
             "sInfoThousands":  ",",
             "sLoadingRecords": this.context.t("Loading"),
             "oPaginate": {
                 "sFirst":    this.context.t("First"),
                 "sLast":     this.context.t("Last"),
                 "sNext":     this.context.t("Next"),
                 "sPrevious": this.context.t("Previous")
             },
             "oAria": {
                 "sSortAscending":  this.context.t(": activate to sort column ascending"),
                 "sSortDescending": this.context.t(": activate to sort column descending")
             }
        }
    });
  }

  componentDidMount () {
    this._getEndpoints()
    //this._getRoles()
  }

  _getRoles() {
      const token = auth.getAccessToken()
      const url = " https://singularmentor.auth0.com/api/v2/roles";

      axios.get(
        url,
        {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              "Authorization" : "Bearer "+token
          }
        }
      ).then(function (response) {



      }).catch(function (error) {


      });
  }

  retry = () => {
    this.setState({
      apiErr: null,
      alertVisible: true,
      loading: true,
      endpoints: []
    }, () => this._getEndpoints())
  }

  dismiss = () => {
    this.setState({ alertVisible: false });
  }

  goBack = () => {
    history.goBack();
  }

  render () {
    const endpoints = this.state.endpoints

    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.apiErr) {
          return (
            <div>
              <Container fluid className="px-0">
                <Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}: {this.state.apiErr.message} </Alert>
              </Container>
                <Container fluid className="main-content-container px-4 pb-4">
                  <div className="error">
                    <div className="error__content">
                      <h2>500</h2>
                      <h3>{this.context.t('Something went wrong!')}</h3>
                      <p>{this.context.t('There was a problem on our end. Please try again later.')}</p>
                      <Button onClick={this.retry} pill><i className="material-icons">refresh</i> {this.context.t('Reload')}</Button>
                    </div>
                  </div>
                </Container>
            </div>
          )
        }

        let error
        if (this.state.apiActionErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiActionErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid className="main-content-container px-4">

                <Row noGutters className="page-header py-4">
                    <PageTitle title={this.context.t('Endpoints')} subtitle={this.context.t('List')} className="text-sm-left mb-3" />
                     <Button size="sm" theme="white" className="mb-2" pill onClick={e => {this.goBack()}}>
                        <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "12px"}}>arrow_back</i>
                    </Button>
                </Row>

                <br/>

                <table id="endpointsTable" className="mdl-data-table" width="100%">
                    <thead>
                        <tr>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        { endpoints && endpoints.length > 0 ? endpoints && endpoints.map(endpoint => {
                              return (
                                <tr key={endpoint.id} style={{ margin: '10px' }}>
                                    <td>
                                         <Card small className="h-100" style={{ marginBottom: '20px'}}>
                                            <CardHeader style={{padding: "10px 10px 0px 10px", borderBottom: "1px solid #fafafa"}}>

                                            </CardHeader>
                                            <CardBody className="pt-0">
                                                <h6 className="m-0">
                                                    <i className="material-icons md-24" style={{float: "left"}}>grain</i>
                                                    <span style={{float: "left", marginTop: "2px", marginLeft: "6px", fontSize: "10px"}}>{endpoint.uri} ({endpoint.version}) </span>
                                                    <Link to={"/endpoints/"+endpoint.id}>
                                                    <Button  size="s" theme="white" className="mb-2 mr-1 pull-right" style={{padding: "5px"}}>
                                                        <i className="material-icons">remove_red_eye</i>
                                                    </Button>
                                                    </Link>
                                                </h6>
                                            </CardBody>
                                          </Card>
                                    </td>
                                </tr>
                              )
                            }) :
                            <tr>
                                <td>
                                    <Alert className="mb-0 info">
                                        <i className="fa fa-info mx-2"></i> {this.context.t('No items loaded')}
                                    </Alert>
                                    <br/>
                                </td>
                            </tr>
                        }
                    </tbody>
                 </table>

            </Container>
            <br/>
            <br/>
          </div>

        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

Endpoints.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(Endpoints)
